import { useCallback } from "react"

import { useField } from "formik"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { I18N_NAMESPACE } from "@l2r-front/l2r-map"
import { MapPointEditor } from "@l2r-front/l2r-networks"

import * as Styled from "./FormikMapPointEditor.styled"

const MAX_DISTANCE_FROM_ROAD = 0.04

export const FormikMapPointEditor = (props) => {

    const {
        children,
        disableMaxDistanceCheck,
        positionFieldName,
        roadFieldName,
        subNetworks,
        ...mapPointEditorProps
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)

    const [_, positionMeta, positionHelpers] = useField({ name: positionFieldName })
    const { error: positionError, value: positionValue } = positionMeta
    const { setValue: setPositionValue, setError: setPositionError } = positionHelpers

    const [__, roadMeta, roadHelpers] = useField({ name: roadFieldName })
    const { value: roadValue } = roadMeta
    const { setValue: setRoadValue } = roadHelpers

    const handleChange = useCallback((data) => {
        setPositionValue({
            longitude: data.longitude,
            latitude: data.latitude,
        }, false)
    }, [setPositionValue])

    const handleRoadDistanceChange = useCallback((roadDistance) => {
        setRoadValue(roadDistance.linearLocation, false)

        if (!disableMaxDistanceCheck && roadDistance.distance >= MAX_DISTANCE_FROM_ROAD) {
            setPositionError(t(I18N_NAMESPACE, "forms.mapPointEditor.pointTooFarError"))
        } else {
            setPositionError(undefined)
        }
    }, [disableMaxDistanceCheck, setPositionError, setRoadValue, t])

    return <Styled.Container>
        <MapPointEditor
            {...mapPointEditorProps}
            position={positionValue}
            road={roadValue.road}
            onMove={handleChange}
            onRoadDistanceChanged={handleRoadDistanceChange}
            subNetworks={subNetworks}
        >
            {children}
        </MapPointEditor>
        <Styled.ErrorMessage variant="Desktop & Mobile/Body/Small">{positionError ?? ""}</Styled.ErrorMessage>
    </Styled.Container>
}